/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SiteCoverPhoto
 */
export interface SiteCoverPhoto {
  /**
   *
   * @type {string}
   * @memberof SiteCoverPhoto
   */
  url?: string | null
}

export function SiteCoverPhotoFromJSON(json: any): SiteCoverPhoto {
  return SiteCoverPhotoFromJSONTyped(json, false)
}

export function SiteCoverPhotoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteCoverPhoto {
  if (json === undefined || json === null) {
    return json
  }
  return {
    url: !exists(json, 'url') ? undefined : json['url']
  }
}

export function SiteCoverPhotoToJSON(value?: SiteCoverPhoto | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    url: value.url
  }
}
